//Librerias
import * as THREE from "three";
//Proyecto
import Maqueta from "./Maqueta";
import {
  obtenerUnidadesPorProyecto,
  obtenerProyectoPorMegaproyecto,
} from "./Interaccion/ConsultarInventario.js";

export default class Inventario {
  constructor() {
    this.maqueta = new Maqueta();
    this.escena = this.maqueta.escena;
    this.recursos = this.maqueta.recursos;

    this.mascarasProyecto = this.maqueta.mundo.mascarasProyecto;
    this.mascarasZonas = this.maqueta.mundo.mascarasZonas;
    this.modoLocal = true;
    this.inventario = null;
    //this.tablaResultados = document.querySelector('#resultados tbody')
    //this.formatoNumero = Intl.NumberFormat('de-DE')
    this.recursos.on("cargado", () => {
      if (this.modoLocal) {
        this.inventario = this.recursos.items.inventario;
        //this.cargarMascarasLocales();
        //this.cargarMascaras();
        //this.cargarMascarasTest();
        console.log("Inventario local: ", this.inventario);
      } else {
        this.cargarInventarioRemoto();
      }
    });
  }
  cargarInventarioRemoto() {
    async function consumo(interaccion) {
      const idMegaProyecto = 230;
      const idProyecto = 901;
      const unidades = await obtenerUnidadesPorProyecto(idProyecto);
      const proyectos = await obtenerProyectoPorMegaproyecto(idMegaProyecto);
      console.log("proyectos:", proyectos);
      console.log("unidades:", unidades);
      if (unidades) {
        interaccion.crearInventario(unidades);
        //interaccion.cargarMascarasTest();
        //interaccion.cargarMascaras();
      } else {
        console.log("Problema al cargar inventario remoto");
      }
    }
    consumo(this);
  }
  crearInventario(data) {
    this.inventario = data;
    console.log("Mi inventario: ", this.inventario);

    // Crear un mapa para relacionar idTipoInmueble con tipoInmueble
    const mapaTipoInmueble = new Map();

    // Crear un objeto para llevar un registro de las repeticiones de idTipoInmueble
    const contadorIdTipoInmueble = {};

    // Recorrer el arreglo de objetos
    for (const objeto of this.inventario) {
      const idTipoInmueble = objeto.idTipoInmueble;
      const tipoInmueble = objeto.tipoInmueble;

      //console.log(tipoInmueble);

      // Relacionar idTipoInmueble con tipoInmueble en el mapa
      mapaTipoInmueble.set(idTipoInmueble, tipoInmueble);

      // Contar las repeticiones de idTipoInmueble
      if (!contadorIdTipoInmueble[idTipoInmueble]) {
        contadorIdTipoInmueble[idTipoInmueble] = 1;
      } else {
        contadorIdTipoInmueble[idTipoInmueble]++;
      }
    }

    // Mostrar los valores y sus repeticiones para idTipoInmueble
    console.log("Conteo de idTipoInmueble:");
    console.log("Mapa:", mapaTipoInmueble);

    //Crear opciones en los filtros
    const selectElement = document.getElementById("tipo_tit");

    // Agrega una opción predeterminada
    const defaultOption = document.createElement("option");
    defaultOption.text = "Selecciona una opción";
    defaultOption.disabled = true;
    defaultOption.selected = true;
    selectElement.appendChild(defaultOption);

    // Recorre el mapaTipoInmueble y agrega opciones al <select>
    for (const [idTipoInmueble, tipoInmueble] of mapaTipoInmueble) {
      if (idTipoInmueble && tipoInmueble) {
        const option = document.createElement("option");
        option.value = idTipoInmueble;
        option.text = tipoInmueble;
        selectElement.appendChild(option);
      }
    }
  }
  cargarMascarasTest() {
    //console.log(this.recursos.items.mascarasInventario.scene.children)
    const nombresMascarasUnidades = [];
    for (const mascara of this.recursos.items.mascarasInventario.scene
      .children) {
      const name = mascara.name;

      nombresMascarasUnidades.push(name);
    }
    console.log(nombresMascarasUnidades)
  }
  // ID ERP nombre: "APT-0201"
  //Nombre actual: torre1_apto901
  //Nombre necesario: TORRE1-APT-0901

  cargarMascaras() {
    
    for (const mascara of this.recursos.items.mascarasInventario.scene
      .children) {
      
      //Ejemplo proyecto Sauces: 'TORRE1-APT-0201'
      //Ejemplo inventario Sausces: "nombre": "APT-0201",
      const name = mascara.name,
        id = name.substring(7, name.length),
        torre = name.substring(
          name.match("TORRE").index + 5,
          name.match("-APT").index
        ),
        num = name.substring(
          name.match("APT").index + 4,
          name.length
        );

      //Consultar inventario
      //const obj = this.inventario.find(obj => obj.id === id)
      const obj = this.inventario.find((obj) => obj.nombre === id);
      
      //Agregar atributos
      mascara.userData.id = id;
      mascara.userData.torre = torre;
      mascara.userData.numero = num;
      mascara.userData.activo = false;
      mascara.userData.disponibilidad = '';
      //mascara.userData.tipo = tipo
      mascara.visible = false;

      if (obj) {
        mascara.userData.disponibilidad = obj.estado;
        //mascara.userData.verDesde =  obj.ver_desde
      } else {
        console.log(name, 'Tiene problemas')
      }

      mascara.userData.activo = false;
      mascara.visible = false;

      //console.log(mascara.userData)
      
      //Definir material
      if(obj) {
        if(obj.estado === 'VENDIDO') {
          mascara.userData.disponibilidad = 'VENDIDO'
          mascara.material = this.maqueta.materiales.materialesProyecto.mascarasVendido
        } else if(obj.estado === 'OPCIONADO') {
          mascara.userData.disponibilidad = 'OPCIONADO'
          mascara.material = this.maqueta.materiales.materialesProyecto.mascarasOpcionado
        } else if(obj.estado === 'BLOQUEADA PARA LA VENTA') { 
          mascara.userData.disponibilidad = 'BLOQUEADA PARA LA VENTA'
          mascara.material = this.maqueta.materiales.materialesProyecto.mascaras
        } else {
          mascara.userData.disponibilidad = 'DISPONIBLE'
          mascara.material = this.maqueta.materiales.materialesProyecto.mascaras
        }
      } else {
        console.log('No se encontró la máscara en el inventario: ', name)
      }

      //Agregar lineas
      let geo = new THREE.EdgesGeometry(mascara.geometry);
      let mat = new THREE.LineBasicMaterial({
        color: this.maqueta.colores.mascaras.mascaraLinea,
        linewidth: 1,
      });
      let wireframe = new THREE.LineSegments(geo, mat);
      mascara.add(wireframe);
    }
    this.mascarasProyecto.add(this.recursos.items.mascarasInventario.scene);
    //this.btnFiltrar.addEventListener('click', ()=> {this.consultar(event, this.inventario)}, false)
    //const unidadInventario = this.inventario.find(obj => obj.id === id)
    //console.log(this.inventario)
  }

  consultar(e, inventario) {
    e.preventDefault();
    e.stopPropagation();

    //Consultar json
    for (const unidad of inventario) {
      //Prender los aptos del JSON
      this.mascarasProyecto.traverse((child) => {
        if (child.type === "Mesh") {
          if (child.userData.id === unidad.id) {
            child.visible = true;
            child.layers.enable(1);
          }
        }
      });
      //Pintar tabla
      const resultado = `<tr data-apto="${unidad.id}">
                <td>${unidad.torre}</td>
                <td>${unidad.apto_tit}</td>
                <td>${unidad.tipo_tit}</td>
                <td>${unidad.habitaciones}</td>
                <td>${unidad.piso}</td>
                <td>${unidad.area_ac}</td>
                <td>$${this.formatoNumero.format(unidad.valor)}</td>
                <td>
                    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.625 1.18751C11.2782 1.17842 12.6875 2.00754 12.6875 4.68751C12.6875 7.36748 6.99995 11.25 6.99995 11.25C6.99995 11.25 1.3125 7.36748 1.3125 4.68751C1.3125 2.00754 2.72178 1.1892 4.375 1.18751C5.25 1.18662 6.45391 1.7364 7.00005 2.50001C7.54609 1.7364 8.74018 1.19238 9.625 1.18751Z" stroke="#70676F" stroke-linejoin="round" />
                    </svg>
                </td>
            </tr>`;

      const tablaResultadosActual = this.tablaResultados.innerHTML;
      this.tablaResultados.innerHTML = tablaResultadosActual + resultado;

      //Actualizar filasApto
      const filasApto = document.querySelectorAll(
        ".listado-resultados tbody tr"
      );

      filasApto.forEach((item) => {
        //item.addEventListener('click', hoverFilaApto, false)
      });
    }
  }
}
